<template>
  <div class="machine-counter-wrapper">
    <hr />
    {{ solutionString }}
  </div>
</template>

<script>
export default {
  props: {
    machineCounter: {
      type: Number,
      default: 0
    }
  },
  computed: {
    solutionString() {
      const solutions = this.machineCounter === 1 ? 'Lösung' : 'Lösungen'
      return `Aktuell ${this.machineCounter} ${solutions}`
    }
  }
}
</script>
